import React from 'react';
export function Problem() {
  return <section className="py-10 px-4 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-94">
          Si estás acá, probablemente te esté pasando esto:
        </h2>

        <ul className="space-y-2 pl-4 text-lg text-gray-700 leading-relaxed" data-id="element-95">
          {['Tu bebé se despierta muchas veces por noche', 'Le cuesta dormirse aunque esté agotado', 'Solo se duerme en brazos, al pecho o en movimiento', 'Las siestas son cortas o impredecibles'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-96">
              <span className="text-red-500 font-bold text-xl" data-id="element-97">❌</span>
              <span data-id="element-98">{item}</span>
            </li>)}
        </ul>

        <div className="my-6 p-5 bg-gray-100 rounded-xl" data-id="element-99">
          <h3 className="font-bold text-xl mb-3 text-gray-900" data-id="element-100">Y vos…</h3>
          <ul className="space-y-2 text-lg text-gray-700" data-id="element-101">
            <li className="flex items-center gap-2" data-id="element-102">😩 Estás agotada</li>
            <li className="flex items-center gap-2" data-id="element-103">
              😩 Dormís mal hace semanas o meses
            </li>
            <li className="flex items-center gap-2" data-id="element-104">
              😫 Sentís que probaste todo
            </li>
            <li className="flex items-center gap-2" data-id="element-105">🤔 Dudás de vos misma</li>
          </ul>
        </div>

        <div className="bg-red-50 border-l-4 border-red-500 p-5 mb-8 rounded-r-lg" data-id="element-106">
          <h3 className="font-bold text-xl mb-1 text-red-800" data-id="element-107">Y lo peor…</h3>
          <p className="text-lg font-semibold text-red-800" data-id="element-108">
            👉 Sentís que nadie tiene una solución que realmente funcione sin
            hacerte sentir culpa
          </p>
        </div>

        <div className="text-center space-y-4" data-id="element-109">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-110">
            Hay algo que tenés que saber (y nadie te dice):
          </h3>

          <div className="bg-blue-50 p-5 rounded-xl inline-block text-left" data-id="element-111">
            <p className="text-xl font-bold text-gray-900 mb-1" data-id="element-112">
              👉 El problema NO es tu bebé
            </p>
            <p className="text-xl font-bold text-gray-900" data-id="element-113">
              👉 El problema NO sos vos
            </p>
          </div>

          <p className="text-xl text-gray-800 font-medium" data-id="element-114">
            El problema es que nadie te enseñó cómo acompañar el sueño de forma
            correcta
          </p>

          <p className="text-2xl font-bold text-gray-900" data-id="element-115">
            Tu bebé no duerme mal 👉 Duerme como un bebé
          </p>

          <p className="text-xl font-bold text-green-600 bg-green-50 p-3 rounded-lg inline-block" data-id="element-116">
            Pero cuando entendés cómo funciona su sueño… 👉 Todo cambia
          </p>
        </div>
      </div>
    </section>;
}